import ForgotPassword from 'screens/ForgotPassword';

export default function ForgotPasswordPage() {
  return <ForgotPassword />;
}
